<template>
  <Command @click="mediaPlayer?.previous()">
    <slot
      v-bind="{
        disabled: !mediaPlayer || !mediaPlayer.can('previous'),
        icon: 'skip_previous',
        label: t('tts.controls.skipPrevious'),
        toolTip: t('tts.controls.skipPrevious'),
      }"
    />
  </Command>
</template>
<script setup lang="ts">
import { inject, Ref } from "vue";
import { useI18n } from "vue-i18n";

import Command from "../command";
import MediaPlayer from "@/services/media/player";

const { t } = useI18n();

const mediaPlayer = inject("mediaPlayer") as Ref<MediaPlayer | null>;
</script>
